"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { usePortfolioContext } from "@/contexts/portfolio-context";
import { useAuthUser, RESTRICTED_ALLOWED_PATHS } from "@/hooks/use-auth-user";

const navItems = [
  // 대시보드는 상단 포트폴리오 탭 바 맨 왼쪽으로 이동 (portfolio-tabs.tsx)
  { href: "/holding", label: "보유종목" },
  { href: "/risk", label: "리스크" },
  { href: "/backtest", label: "백테스트" },
  { href: "/performance", label: "성과" },
  { href: "/trades", label: "거래내역" },
  { href: "/presets", label: "차수설정" },
  { href: "/group-mapping", label: "그룹매핑" },
  { href: "/sector-performance", label: "그룹현황" },
  { href: "/settings", label: "설정" },
  { href: "/etf", label: "ETF(kr)" },
  { href: "/etf-us", label: "ETF(us)" },
  { href: "/stock", label: "Stock" },
];

export function Header() {
  const pathname = usePathname();
  // 선택된 포트폴리오가 momentum 전략이면 활성 메뉴를 빨강으로 표시
  const { portfolios, selectedPortfolio } = usePortfolioContext();
  const isMomentum = portfolios.find((p) => p.name === selectedPortfolio)?.strategy === "momentum";
  const activeBg = isMomentum ? "bg-[#ff3b30]" : "bg-[#0071e3]";

  // 로그인 사용자는 허용 페이지(보유종목/성과/거래내역) 메뉴만
  const { restricted } = useAuthUser();
  const items = restricted ? navItems.filter((i) => RESTRICTED_ALLOWED_PATHS.includes(i.href)) : navItems;

  return (
    <header className="hidden md:block w-full border-b border-black/[0.08]" style={{ background: "#ffffff" }}>
      <div className="w-full flex h-[40px] items-center px-6">
        <nav className="flex items-center gap-2">
          {items.map((item) => {
            const isActive = pathname === item.href;
            return (
              <Link
                key={item.href}
                href={item.href}
                className={cn(
                  "text-xs tracking-[-0.12px] transition-colors px-3 py-1 rounded-full",
                  isActive
                    ? `${activeBg} text-white font-semibold`
                    : "text-black/70 hover:text-neutral-900 font-normal"
                )}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>
        {/* 리스크관리 가이드 — 메뉴 반대편 오른쪽 끝. docs/RiskManagement.html (public 심볼릭 링크) 새 탭 */}
        <a
          href="/RiskManagement.html"
          target="_blank"
          rel="noopener"
          className="ml-auto shrink-0 text-xs tracking-[-0.12px] px-3 py-1 rounded-full text-black/55 hover:text-neutral-900 hover:bg-black/[0.05] transition-colors"
          title="리스크 관리 가이드 — 최대손실폭·차수별 매수금액·최대차수"
        >
          리스크관리
        </a>
      </div>
    </header>
  );
}
